// extracted by mini-css-extract-plugin
export default {"botLink":"BotMessage_botLink__Z5Fup","bold":"BotMessage_bold__UkYK2"};